import './App.css';
import  { JsonViewer }  from "json-viewer-react"
import  json  from './exampleJson.json';
import React from 'react';

function App() {
  return (
    <div className="App">
      <JsonViewer json={json} />
    </div>
  );
}

export default App;
